/* eslint-disable */
//import images from 'assets/images/images'
import images from 'assets/images/images'
import IncDecrement from 'components/IncDecrement'
import SimpleAccordion from 'components/accordion/SimpleAccordion'
import Input from 'components/form-elements/Input'
import Button from 'components/form-elements/buttons/Button'
import Checkbox from 'components/form-elements/checkbox/Checkbox'
//import Checkbox from 'components/form-elements/checkbox/Checkbox'
import Radio from 'components/form-elements/radio/Radio'
import ReactSelect from 'components/form-elements/select/ReactSelect'
import { useRequest } from 'hooks/useRequest'
import useTranslate from 'hooks/useTranslate'
import Loader from 'pages/Loader'
import LoaderTwo from 'pages/LoaderTwo'
import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { authModalOpen, getAllBasketFunc } from 'redux/features/general/generalSlice'
import auth from 'utils/Auth'
import { FormattedNumber, IntlProvider } from 'react-intl'
import Textarea from 'components/form-elements/textArea/Textarea'
import { dataLayerPush } from 'utils/Datalayer'

const AdditionalProduct = ({ getItem, loadingProp, isOpenDrawer }) => {
	const [productCount, setProductCount] = useState(1)
	const [request, loading] = useRequest()
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const [product, setProduct] = useState()
	const { t } = useTranslate()


	useEffect(() => {
		setProduct(getItem)

		if(product && getItem){
			dataLayerPush({ ecommerce: null });
			dataLayerPush({
				event:"view_item",
				item_list_name: "Listeleme Sayfası",
				ecommerce: {
					item_list_name: "Listeleme Sayfası",
					currency: "TRY",
					value: product?.price,
					items: [product]?.map((prev, i) => ({
						item_id: prev.id,
						item_name: prev.name,
						affilication: "Tavuk Dünyası",
						discount: prev.discountAmount,
						index: i,
						item_brand: "Tavuk Dünyası",
						item_category: prev.categories?.[0]?.value,
						item_category2: prev.categories?.[1]?.value ? prev.categories?.[1]?.value : "",
						item_category3: prev.categories?.[2]?.value ? prev.categories?.[2]?.value: "",
						item_list_name: "Listeleme Sayfası",
						price: prev.price,
						quantity: productCount
					}))
				}
			})
		}
	}, [getItem])


	const handleOnChange = (e, attValue, attribute, type) => {
		if (type == 'checkbox') {
			setProduct((prev) => ({
				...prev,
				attributes: prev.attributes.map((attr) => {
					if (attr.id == attribute.id) {
						return {
							...attr,
							values: attr.values.map((val) => {
								if (val.id == attValue.id) {
									return { ...val, isPreSelected: e.target.checked }
								} else {
									return { ...val }
								}
							}),
						}
					} else {
						return attr
					}
				}),
			}))
		} else if (type == 'dropdown') {
			setProduct((prev) => ({
				...prev,
				attributes: prev.attributes.map((attr) => {
					if (attr.id == attribute.id) {
						return {
							...attr,
							values: attr.values.map((val) => {
								if (val.id == attValue.id) {
									return { ...val, isPreSelected: true }
								} else {
									return { ...val, isPreSelected: false }
								}
							}),
						}
					} else {
						return { ...attr }
					}
				}),
			}))
		} else if (type == 'radio') {
			setProduct((prev) => ({
				...prev,
				attributes: prev.attributes.map((attr) => {
					if (attr.id == attribute.id) {
						return {
							...attr,
							values: attr.values.map((val) => {
								if (val.id == attValue.id) {
									return { ...val, isPreSelected: e.target.checked }
								} else {
									return { ...val, isPreSelected: false }
								}
							}),
						}
					} else {
						return attr
					}
				}),
			}))
		}
	}

	const headerOptions = {
		RestaurantId: auth?.getUserChoises()?.restaurantId,
		DeliveryType: auth?.getUserChoises()?.deliveryType,
		NeighbourhoodId: auth?.getUserChoises()?.neighbourhoodId,
		RegionId: auth?.getUserChoises()?.regionId,
	}

	const getPostArray = () => {
		const mappedArray =
			product?.attributes?.filter((a) => a.controlType == 3)?.length > 0
				? product?.attributes
						?.filter((a) => a.controlType == 3)
						?.map((attribute) => {
							return [
								...attribute.values.map((element) => {
									return {
										productAttributeId: attribute.id,
										value: element?.isPreSelected ? element?.id?.toString() : null,
										price: element?.isPreSelected ? element?.price : null,
										parentProductAttributeId: attribute.parentProductAttributeId,
									}
								}),
							]
						})
				: []
		const mappedArrayWithoutType3 = product?.attributes
			?.filter((a) => a.controlType != 3)
			?.map((attribute) => {
				switch (attribute.controlType) {
					case 1:
						return {
							productAttributeId: attribute.id,
							value: attribute?.values?.find((att) => att.isPreSelected) ? attribute?.values?.find((att) => att.isPreSelected)?.id?.toString() : null,
							price: attribute?.values?.find((att) => att.isPreSelected) ? attribute?.values?.find((att) => att.isPreSelected)?.price : null,
							parentProductAttributeId: attribute.parentProductAttributeId,
						}
					case 2:
						return {
							productAttributeId: attribute.id,
							value: attribute?.values?.find((att) => att.isPreSelected) ? attribute?.values?.find((att) => att.isPreSelected)?.id?.toString() : null,
							price: attribute?.values?.find((att) => att.isPreSelected) ? attribute?.values?.find((att) => att.isPreSelected)?.price : null,
							parentProductAttributeId: attribute.parentProductAttributeId,
						}
					case 4:
						return {
							productAttributeId: attribute.id,
							value: attribute?.defaultValue ? attribute?.defaultValue : null,
							parentProductAttributeId: attribute.parentProductAttributeId,
						}
					case 5:
						return {
							productAttributeId: attribute.id,
							value: attribute?.defaultValue ? attribute?.defaultValue : null,
							parentProductAttributeId: attribute.parentProductAttributeId,
						}
					case 6:
						return {
							productAttributeId: attribute.id,
							value: attribute?.values?.find((att) => att.isPreSelected) ? attribute?.values?.find((att) => att.isPreSelected)?.id?.toString() : null,
							price: attribute?.values?.find((att) => att.isPreSelected) ? attribute?.values?.find((att) => att.isPreSelected)?.price : null,
							parentProductAttributeId: attribute.parentProductAttributeId,
						}
					default:
						return { value: null }
				}
			})
		const postArray =
			mappedArray[0]?.length > 0
				? [
						// eslint-disable-next-line no-unsafe-optional-chaining
						...mappedArrayWithoutType3,
						...mappedArray[0],
				  ]?.filter((a) => a.value != null)
				: mappedArrayWithoutType3?.length > 0
				? [...mappedArrayWithoutType3]?.filter((a) => a.value != null)
				: []
		return postArray
	}
	const addBasket = () => {

		if (!auth.isHaveToken()) {
			return dispatch(authModalOpen({open:true,returnUrl:`/urun/${product?.url}`}))
		}
		const newData = {
			productId: product?.id,
			quantity: productCount,
			attributes: getPostArray(),
		}
		request('/ShoppingCart/UpdateCart', {
			method: 'POST',
			data: newData,
			headers: headerOptions,
		}).then((res) => {
			if (res.data) {
				if(product){
					dataLayerPush({ ecommerce: null });
					dataLayerPush({
					  event:"add_to_cart",
					  ecommerce: {
						item_list_name: "Listeleme Sayfası",
						currency: "TRY",
						value: product?.price,
						items: [product]?.map((prev, i) => ({
						  item_id: prev.id,
						  item_name: prev.name,
						  affilication: "Tavuk Dünyası",
						  discount: prev.discountAmount,
						  index: i,
						  item_brand: "Tavuk Dünyası",
						  item_category: prev.categories?.[0]?.value,
						  item_category2: prev.categories?.[1]?.value ? prev.categories?.[1]?.value : "",
						  item_category3: prev.categories?.[2]?.value ? prev.categories?.[2]?.value: "",
						  item_list_name: "Listeleme Sayfası",
						  price: prev.price,
						  quantity: productCount
						}))
					  }
					})
				  }
				toast.success(t('productAddedToCart'))
				dispatch(getAllBasketFunc(res?.data?.result))
				navigate('/odeme')
			}
		})
	}

	const textChoice = (e, attribute) => {
		let text = e.target.value
		setProduct((prev) => ({
			...prev,
			attributes: prev.attributes.map((attr) => {
				if (attr.id == attribute.id) {
					return { ...attr, defaultValue: text }
				} else {
					return attr
				}
			}),
		}))
		//getLastObjectsWithSameID(textChange)
	}
	const otherChoice = (e, attribute) => {
		handleOnChange(e, JSON.parse(e.target.value), attribute, 'dropdown')
	}

	return (
		<div className='additionalProduct'>
			{/* <div className='additionalProduct-badge'>
            <img src={images.stars} alt="" />
            <div>Süper Tavuklu Kampanyası</div>
        </div> */}
			{product?.appliedCampaigns?.[0]?.value && (
				<div className='additionalProduct-badge'>
					<img src={images.stars} alt='' />
					<div>{getItem?.appliedCampaigns?.[0]?.value}</div>
				</div>
			)}
			<LoaderTwo isDataLoading={loading} />
			{
				loadingProp && <div>
					<div className='skeleton skeleton-text'/>
					<div className='skeleton skeleton-footer'/>
				</div>
			}
			{
				getItem && !loadingProp && <div className='additionalProduct-text'>
				<h1 className='additionalProduct-text-title'>{getItem?.name}</h1>
				<div className='additionalProduct-text-price'>
					{
						<IntlProvider locale={'tr'} defaultLocale='en'>
							<FormattedNumber maximumFractionDigits={0} minimumFractionDigits={0} value={getItem?.discountedPrice} style={'decimal'} />
						</IntlProvider>
					}{' '}
					TL
				</div>
				{getItem?.discountedPrice != getItem?.price && (
					<div className='additionalProduct-text-oldprice d-flex align-items-start'>
						{
							<IntlProvider locale={'tr'} defaultLocale='en'>
								<FormattedNumber maximumFractionDigits={0} minimumFractionDigits={0} value={getItem?.price} style={'decimal'} />
							</IntlProvider>
						}{' '}
						TL
					</div>
				)}
			</div>
			}

			{/* <div className="form-control mt-4 pt-2">
            <div className="form-control-label">Zeytinyağı & Limon Sosu Tercihi</div>
            <div className='d-flex flex-column'>
                <div className='radio-list-item'><Radio className='radio-orange' name={10}/> <span className='flex-1 header-s'>Zeytinyağı & Limon Sosu istemiyorum</span> <span className='header-m text-orange'>Ücretsiz</span></div>
                <div className='radio-list-item'><Radio className='radio-orange' name={10}/> <span className='flex-1 header-s'>Zeytinyağı & Limon Sosu istiyorum</span> <span className='header-m text-orange'>Ücretsiz</span></div>
            </div>
        </div> */}
			<div className='additionalProduct-list'>
				{
					loadingProp && <>
					<div className='skeleton skeleton-text'/>
					<div className='skeleton skeleton-text'/>
					<div className='skeleton skeleton-text'/>
					
					</>
				}

				{
					// product?.attributes?.map((attribute,index) => ( sadece attributestan gelecek...
					product?.attributes?.length > 0 && product?.attributes?.map((attribute, index) => {
						return attribute?.controlType == 2 ? (
							<SimpleAccordion
								border
								key={index}
								header={
									<div className={`d-flex flex-column ${attribute?.values?.find((att) => att.isPreSelected)?.name ? 'gap-3' : 'gap-0'}`}>
										<div className='body-m'>{attribute?.name}</div>
										<div className='body-s'>
											{/* bu kısmın revize edilmesi lazım */}
											{attribute?.values?.find((att) => att.isPreSelected)?.name}
										</div>
									</div>
								}
								content={
									<div className='d-flex flex-column'>
										{attribute?.values.map((att, i) => (
											<div key={i} className='radio-list-item'>
												<Radio
													onChange={(e) => handleOnChange(e, att, attribute, 'radio')}
													className='radio-orange'
													value={JSON.stringify(att)}
													id={`radio${attribute.id}${att.id}`}
													name={`radio${index}`}
													checked={att.isPreSelected}
												/>
												<span className='flex-1 header-s'>{att?.name}</span>
												<span className='header-m text-orange'>{att?.price == 0 ? t('free') : `${att?.price} TL`}</span>
											</div>
										))}
									</div>
								}
							/>
						) : attribute?.controlType == 3 ? (
							<SimpleAccordion
								border
								header={
									<div
										className={`d-flex flex-column ${
											attribute?.values
												?.filter((att) => att.isPreSelected)
												?.map((att) => att.name)
												?.join(',')
												? 'gap-3'
												: 'gap-0'
										} `}
									>
										<div className='body-m'>{attribute?.name}</div>
										<div className='body-s'>
											{attribute?.values
												?.filter((att) => att.isPreSelected)
												?.map((att) => att.name)
												?.join(',')}
										</div>
									</div>
								}
								content={
									<div className='d-flex flex-column'>
										{attribute?.values.map((att, i) => (
											<div className='additionalProduct-addproduct-check' key={i}>
												<Checkbox
													onChange={(e) => handleOnChange(e, att, attribute, 'checkbox')}
													className={'checkbox checkbox-orange'}
													textLabel={''}
													checked={att.isPreSelected}
												/>
												<div className='header-s flex-1'>{att?.name}</div>
												<div className='header-m text-orange'>{att?.price == 0 ? t('free') : `${att?.price} TL`}</div>
											</div>
										))}
									</div>
								}
							/>
						) : attribute?.controlType == 4 ? (
							<Input
								containerClassName={''}
								className={'inp'}
								placeholder={attribute?.name}
								type={'text'}
								value={attribute?.defaultValue}
								textLabel={''}
								name=''
								maxLength={attribute?.validationMaxLength && attribute?.validationMaxLength}
								onChange={(e) => textChoice(e, attribute)}
							/>
						) : //  <input className='inp' type="text" value={attribute?.defaultValue} placeholder={attribute?.name} onChange={(e) => textChoice(e,attribute)}/>
						attribute?.controlType == 5 ? (
							<div className='d-flex flex-column gap-1 mt-3'>
								{/* <div className='body-m'>Ürün Notu</div> */}
								{attribute?.description && <div className='body-m'>{attribute?.description}</div>}
								<Textarea 
									id='textareaChange'
									value={attribute?.defaultValue}
									onChange={(e) => textChoice(e, attribute)}
									cols='30'
									rows='10'
									maxLength={attribute?.validationMaxLength && attribute?.validationMaxLength}
								/>
							</div>
						) : attribute?.controlType == 1 ? (
							<div className='form-control mt-4'>
								<div className='form-control-label body-m'>{attribute?.name}</div>
								<select className='body-m' onChange={(e) => otherChoice(e, attribute)} name='' id='selectAdd'>
									<option value='' hidden>{t('choosePlaceholder')}</option>
									{attribute?.values.map((att, i) => (
										// <div className='additionalProduct-addproduct-check' key={i}>

										<option key={i} selected={att.isPreSelected} value={JSON.stringify(att)} className={'checkbox checkbox-orange'}>
											{att?.name}
										</option>
										// </div>
									))}
								</select>
							</div>
						) : (
							''
						)
					})
				}
			</div>

			
			{
				getItem && !loadingProp && !isOpenDrawer && <div className='additionalProduct-select'>
				{/* <select name="" id="">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
            </select> */}
				<IncDecrement setProductCount={setProductCount} productCount={productCount} />
				<Button
					onClick={addBasket}
					className={'claretredRoundedBtn'}
					icon={''}
					text={t('addToCardWithCount', {
						productCount: productCount,
						price: (
							productCount *
							(product?.discountedPrice +
								getPostArray()
									?.filter((a) => a?.price)
									?.reduce((a, b) => a + b?.price, 0))
						)?.toFixed(2),
					})}
				/>
			</div>
			}
		</div>
	)
}

export default AdditionalProduct
